var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"5","height":"4","viewBox":"0 0 5 4"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.5 4L5 0H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }